import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects legacy /course/:courseId/module/:moduleId/lesson/:lessonId URLs
 * to the new /courses/:courseId/:moduleId/:lessonId format.
 */
export function CourseRedirect() {
  const { courseId, moduleId, lessonId } = useParams<{
    courseId: string;
    moduleId?: string;
    lessonId?: string;
  }>();

  if (moduleId && lessonId) {
    return <Navigate to={`/courses/${courseId}/${moduleId}/${lessonId}`} replace />;
  }
  if (moduleId) {
    return <Navigate to={`/courses/${courseId}`} replace />;
  }
  return <Navigate to={`/courses/${courseId}`} replace />;
}
